"use strict";

import React, { Component } from "react";
import PropTypes from "prop-types";

import 'flot/dist/es5/jquery.flot';
import 'flot/source/jquery.flot.time';
import 'flot/source/jquery.flot.categories';
import 'flot/source/jquery.flot.logaxis';

class VideoEnrichmentEventChart extends Component {
    static propTypes = {
        eventChartId: PropTypes.string,
        options: PropTypes.object,
        color: PropTypes.string,
        data: PropTypes.array,
    };

    static defaultProps = {
        color: '#b5bbc8',
        data: [],
    };

    constructor(props) {
        super(props);

        let defaultOptions = {
            grid: {
                borderWidth: { top: 0, right: 0, bottom: 1, left: 0 },
                markings: {xaxis: [], yaxes: []} ,
            },
            xaxis: {
                mode: "time",
                timezone: "browser",
                timeBase: "milliseconds",
            },
            series: {
                color: props.color,
                bars: {
                    show: true,
                },
            },
        };

        this.state = {
            options: props.options || defaultOptions,
        };
    }

    componentDidMount() {
        this.initFlotChart();
    }

    componentDidUpdate(prevProps, prevState) {
        this.initFlotChart();
    }

    initFlotChart() {
        const { eventChartId, data } = this.props;
        const { options } = this.state;

        $.plot($('#' + eventChartId), (data && [data]) || [[]], options);
    }

    render() {
        const { eventChartId, data } = this.props;

        return (
            <div>
                <div id={eventChartId} ref='eventchart' style={{height:"200px", display: data && (data.length > 0) ? "block" : "none"}} />
                <div style={{height:"200px", display: data && (data.length > 0) ? "none" : "block"}}>
                    <h2>Loading...</h2>
                </div>
            </div>
        )
    }
}

export default VideoEnrichmentEventChart;
